import { billingSubscriptionTransaction } from "../../../../models/axiosModel";
import { formatDateTime } from "../../../../utils/constants";
import { getTransactionAmount, getTransactionInvoiceUrl } from "./transactionUtils";

import InvoiceCell from "./invoiceCell";
import StatusChip from "./statusChip";

export const transactionColumns = [
    {
        name: "Charge Date",
        alignment: "left",
        valueKey: "transaction_charge_date",
        renderCell: (row: billingSubscriptionTransaction) =>
            row?.transaction_charge_date ? formatDateTime(row.transaction_charge_date, "dmyFull24hrFormat") : "-",
    },
    {
        name: "Paid Date",
        alignment: "left",
        valueKey: "transaction_paid_at",
        renderCell: (row: billingSubscriptionTransaction) =>
            row?.transaction_paid_at ? formatDateTime(row.transaction_paid_at, "dmyFull24hrFormat") : "-",
    },
    {
        name: "Description",
        alignment: "left",
        valueKey: "transaction_description",
        renderCell: (row: billingSubscriptionTransaction) =>
            row?.transaction_description ? row.transaction_description : "-",
    },
    {
        name: "Status",
        alignment: "left",
        valueKey: "transaction_status",
        renderCell: (row: billingSubscriptionTransaction) => <StatusChip status={row?.transaction_status || ""} />,
    },
    {
        name: "Amount",
        alignment: "left",
        valueKey: "transaction_amount",
        renderCell: (row: billingSubscriptionTransaction) =>
            row?.transaction_amount ? getTransactionAmount(row) : "-",
    },
    {
        name: "Invoice",
        alignment: "left",
        valueKey: "transaction_razorpay_invoice_id",
        renderCell: (row: billingSubscriptionTransaction) => (
            <InvoiceCell url={getTransactionInvoiceUrl(row)} />
        ),
    },
];
